import React from "react";
import { Container, Navbar, Nav } from "react-bootstrap";

const Footer = () => {
  return (
    <Navbar expand="lg" variant="light" className="justify-content-between">
      <Container>
        <Nav className="me-auto"></Nav>
      </Container>
    </Navbar>
  );
};

export default Footer;
